const d3 = Object.assign(
    {},
    require("d3-selection"),
    require("d3-brush"),
    require("d3-transition"),
    require("d3-ease")
)

export function drawBrush(zoomValue) {
    
    this.zoomScale = zoomValue

    let locStorage = JSON.parse(localStorage.getItem("d3_cameraSettings"))
    locStorage.settings.zoomScale = this.zoomScale
    window.localStorage.setItem("d3_cameraSettings", JSON.stringify(locStorage))

    const dimensions = this.dimensions // for nested functions
    const scaleX = this.scaleX

    const brushDim = {}
    brushDim.top = 10
    brushDim.bottom = 35

    this.brushWidth =
        (this.dimensions.width -
            this.dimensions.margin.left -
            this.dimensions.margin.right) /
        zoomValue

    // create fake row
    const lineY = (brushDim.bottom - brushDim.top) / 2 + brushDim.top

    let zoomBrush, fakeCircles

    if (d3.select(".brush").empty()) {
        zoomBrush = this.wrapper.append("g").attr("id", "brush")
        zoomBrush
            .append("line")
            .attr("x1", this.dimensions.margin.left)
            .attr("y1", lineY)
            .attr("x2", this.dimensions.width - this.dimensions.margin.right)
            .attr("y2", lineY)
            .attr("class", "grid-line")
            .attr("stroke", "#ccc")
            .attr("stroke-width", 0.5)

        fakeCircles = zoomBrush
            .selectAll("circle")
            .data(this.sumView)
            .enter()
            .append("circle")
            .attr("cy", lineY)
            .attr("cx", this.dimensions.margin.left)
            .transition()
            .duration(400)
            .ease(d3.easeCubicInOut)
            .attr("cx", d => this.scaleBrush(d[0]))
            .attr("r", d => 3)
            .attr("fill", "#31eae1")
            .attr("stroke", "black")
            .attr("stroke-width", 1)
            .attr("class", "fakeCircle")
    } else {
        zoomBrush = this.wrapper.select("#brush")

        zoomBrush
            .selectAll("circle")
            .transition()
            .duration(400)
            .ease(d3.easeCubicInOut)
            .attr("cx", d => this.scaleBrush(d[0]))
    }

    // create fake row END

    const brush = d3
        .brushX()
        .extent([
            [this.dimensions.margin.left, brushDim.top],
            [
                this.dimensions.width - this.dimensions.margin.right,
                brushDim.bottom
            ]
        ])
        .on("brush", () => {
            brushDrawing(this)
        })

    zoomBrush.attr("class", "brush").call(brush)

    brush.move(d3.select(".brush"), [
        this.dimensions.margin.left,
        this.dimensions.margin.left + this.brushWidth
    ])
}

function brushDrawing(obj) {

    obj.hideToolTip()
    let locStorage = JSON.parse(localStorage.getItem("d3_camera"))
    d3.getEvent = () => require("d3-selection").event
    const brushPoint = d3.getEvent().selection

    // Increase Range according to zoom
    const newPoint = [
        obj.dimensions.margin.left,
        (obj.dimensions.width - obj.dimensions.margin.right) * obj.zoomScale
    ]
    obj.scaleX.range(newPoint)

    // relative start point to be substracted
    const relativePoint =
        obj.zoomScale * (brushPoint[0] - obj.dimensions.margin.left)

    for (let property in locStorage) {
        let brandName = locStorage[property].brandName

        const brand = d3.select(`#${brandName}`)

        if (obj.zoomScale > 1) {
            brand.selectAll("circle").attr("clip-path", "url(#clip)")
        } else {
            brand.selectAll("circle").attr("clip-path", "url(#clipWide)")
        }

        brand
            .selectAll("circle")
            .transition()
            .duration(500)
            .ease(d3.easeCubicOut)
            .attr("cx", (d, i) => {
                if (d[obj.selectedDimension] > 0) {
                    const myValue =
                        obj.scaleX(d[obj.selectedDimension]) - relativePoint
                    return myValue
                } else {
                    return (
                        obj.dimensions.width - obj.dimensions.margin.right / 2
                    )
                }
            })
            .attr("r", d => obj.scaleR(d.amount))
            .attr("opacity", 0.3)
            .attr("stroke", "black")
            .attr("stroke-width", 1)
    }

    // SELECT MODEL CONTAINER
    const model = d3.select(`#model`)
    if (obj.zoomScale > 1) {
        model.selectAll("circle").attr("clip-path", "url(#clip)")
    } else {
        model.selectAll("circle").attr("clip-path", "url(#clipWide)")
    }

    model
        .selectAll("circle")
        .transition()
        .duration(500)
        .ease(d3.easeCubicOut)
        .attr("cx", (d, i) => {
            if (d[obj.selectedDimension] > 0) {
                const myValue =
                    obj.scaleX(d[obj.selectedDimension]) - relativePoint
                return myValue
            } else {
                return obj.dimensions.width - obj.dimensions.margin.right / 2
            }
        })
        .attr("r", d => obj.scaleR(d.amount))
        .attr("opacity", 0.3)
        .attr("stroke", "black")
        .attr("stroke-width", 1)

    // SELECT MODEL CONTAINER END

    d3.select(".brush")
        .selectAll("circle")
        .attr("opacity", (d, i) => {
            const dim =
                (obj.dimensions.boundedWidth / 100) * d +
                obj.dimensions.margin.left
            if (isBrushed(brushPoint, dim)) {
                return 0.7
            } else {
                return 0.15
            }
        })

    function isBrushed(brush_coords, cx) {
        var x0 = brush_coords[0],
            x1 = brush_coords[1]
        return x0 <= cx && x1 >= cx
    }
}

export function removeBrush() {
    this.drawBrush(1)

    d3.select(".brush").on(".brush", null)
    d3.select(".selection")
        .transition()
        .duration(300)
        .attr("fill-opacity", 0)
        .attr("stroke", "none")
        .end()
        .then(() => {
            d3.select(".brush").remove()
        })
}

export default drawBrush
